import { render } from "./PeriodSelector.vue?vue&type=template&id=54513751&ts=true"
import script from "./PeriodSelector.vue?vue&type=script&lang=ts"
export * from "./PeriodSelector.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__